export const config = {
  introTween: {
    type: 'scaleLoop',
    duration: 0.5,
    ease: 'Expo.InOut',
    scale: { x: 1.1, y: 1.1 },
    delay: 0.2,
    yoyo: true,
  },
  introAlpha: {
    type: 'alphaLoop',
    duration: 1,
    ease: 'Expo.InOut',
    alpha: 0,
    delay: 1,
    yoyo: true,
  },
}
